import React, { Component } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from 'material-ui/styles';
import { withRouter } from 'react-router';

import paths, { getTitle } from '../lib/nav-paths';
import AppBody from './AppBody';
import AppHead from './AppHead';
import AppDrawer from './AppDrawer';
import { getProjectTitle } from '../reducers';

const styles = theme => ({
  '@global': {
    html: {
      boxSizing: 'border-box',
    },
    '*, *:before, *:after': {
      boxSizing: 'inherit',
    },
    body: {
      margin: 0,
      background: theme.palette.background.default,
      color: theme.palette.text.primary,
      lineHeight: '1.2',
      overflowX: 'hidden',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
  },
  root: {
    display: 'flex',
    alignItems: 'stretch',
    minHeight: '100vh',
    width: '100%',
  },
});

export class AppFrame extends Component {
  constructor(props){
    super(props);
    this.state = {
      drawerOpen: false,
    };
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleDrawerClose() {
    this.setState({ drawerOpen: false });
  }

  handleDrawerOpen() {
    this.setState({ drawerOpen: true });
  }

  handleDrawerToggle() {
    const { drawerOpen } = this.state;
     this.setState({ drawerOpen: !drawerOpen })
  }

  handleLogin() {
    console.log("Loging in..."); // eslint-disable-line no-console
  }

  render() {
    const { children, classes, location, projectTitle } = this.props;
    const { drawerOpen } = this.state;
    const title = getTitle(location.pathname, projectTitle);
    const disablePermanent = title === '';
    const pathArray = location.pathname.split('/').filter(x => x);
    const showAppMenu = pathArray.length > 0 && pathArray[0] === 'app';

    return (
      <div className={classes.root}>
        <AppHead
          title={title}
          showAppMenu={showAppMenu}
          handleDrawerToggle={this.handleDrawerToggle}
          handleLogin={this.handleLogin}
        />
        <AppDrawer
          navPaths={paths}
          disablePermanent={disablePermanent}
          onClose={this.handleDrawerClose}
          onOpen={this.handleDrawerOpen}
          open={drawerOpen}
        />
        <AppBody disableAppDrawer={disablePermanent}>
          { children }
        </AppBody>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectTitle: getProjectTitle(state)
  }
}

AppFrame.propTypes = {
  children:     PropTypes.node.isRequired,
  classes:      PropTypes.shape({
    root: PropTypes.string
  }).isRequired,
  location:     ReactRouterPropTypes.location.isRequired,
  projectTitle: PropTypes.string,
}

AppFrame.defaultProps = {
  projectTitle: ''
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps),
)(AppFrame);



// WEBPACK FOOTER //
// ./src/components/AppFrame.js